<template>
  <div class="newTask">
    <div class="newTask__header">
      <div class="newTask__header__top">
        <img src="/img/icons/ic-arrow-left.svg" alt="">
        <span class="regular-font" @click="backToAssignment">Assignment</span>
      </div>
      <div class="newTask__header__bottom">
        <h1 class="medium-title">Add New Task</h1>
      </div>
    </div>
    <div v-if="!isLoading" class="newTask__body">
      <div class="newTask__body__left">
        <div class="newTask__body__left__wrapper">
          <!-- Priority will exist at next version -->
          <!-- <div class="newTask__body__left__wrapper__row">
            <adx-dropdown :label="`Task Category`" class="dropdown" :value.sync="data.category" :options="dummyOptions"/>
            <adx-dropdown :label="`Priority`" class="dropdown" :value.sync="data.priority" :options="dummyOptions"/>
          </div> -->
          <adx-dropdown 
            :label="`Task Category`"
            class="dropdown"
            :value.sync="data.categoryDropdown"
            :options="categoryOptions"
            :ref="dataRef.categoryDropdown"
            :error.sync="errors.categoryDropdown"
            :validation="['NewNotEmpty']"
            />
          <adx-single-search-dropdown
            class="dropdown"
            :label="`Select Campaign`"
            :optionsParam="campaignOptions"
            :value.sync="data.campaignDropdown"
            :ref="dataRef.campaignDropdown"
            :error.sync="errors.campaignDropdown"
            :validation="['NewNotEmpty']"
          />
          <adx-single-search-dropdown
            v-if="data.campaignDropdown && !isLocationLoading"
            class="dropdown"
            :label="`Placement`"
            :optionsParam="locationOptions"
            :value.sync="data.locationDropdown"
            :ref="dataRef2.locationDropdown"
            :error.sync="errors.locationDropdown"
            :validation="['NewNotEmpty']"
          />
          <loading-primary class="loadingLocation" v-if="isLocationLoading"/>
        </div>
      </div>
      <div class="newTask__body__right">
        <div class="newTask__body__right__wrapper">
          <adx-single-search-dropdown
            class="dropdown"
            :label="`Select User`"
            :optionsParam="userOptions"
            :value.sync="data.userDropdown"
            :ref="dataRef2.userDropdown"
            :error.sync="errors.userDropdown"
          />
          <div :class="['calendar', this.errors.startDate ? 'calendarError' : '']">
            <label class="small-font">Start Date</label>
            <v-date-picker
              v-model='data.startDate'
              :max-date='maxDate'
              :min-date='new Date()'
              :popoverVisibility="'focus'"
              :theme-styles='themeStyles'
              class='date-input'>
              <input
                class="calendar-start"
                placeholder= "DD/MM/YYYY"
                type='text'
                slot-scope='{ inputValue, updateValue }'
                :value='inputValue'
                @input='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
                @change='updateValue($event.target.value, { formatInput: true, hidePopover: false })'>
            </v-date-picker>
          </div>
          <div class="calendarErrorMessage" v-if="errors.startDate">This field is required! Please enter Start Date</div>
          <adx-checkbox class="checkbox" :label="`Recurring Task`" :value.sync="data.recurring" :valueLabel="`recurring`"/>
        </div>
        <button class="btn-large primary" @click="save">Save Task</button>
      </div>
    </div>
    <loading-primary class="newTask__loading" v-else/>
  </div>
</template>

<script>
import Checkbox from "@/components/Form/Checkbox"
import Dropdown from "@/components/Form/SelectDropdown"
import SingleSearchDropdown from "@/components/Dropdown/SingleSearchDropdown"
import LoadingPrimary from '@/components/Loading/Primary'
import moment from 'moment'
import triggerValidation from "@/lib/triggerValidation"
import calendar from 'v-calendar'
import api from '@/api'
import { apiV2 } from '@/api/urls'

export default {
  name: 'adx-new-task',
  components: {
    "adx-checkbox": Checkbox,
    "adx-single-search-dropdown": SingleSearchDropdown,
    "adx-dropdown": Dropdown,
    'v-calendar': calendar,
    'loading-primary': LoadingPrimary,
  },
  props: {

  },
  data() {
    return {
      minDate: new Date(),
      maxDate: null,
      isLoading: false,
      isLocationLoading: false,
      campaignOptions: [],
      userOptions: [],
      locationOptions: [],
      storedCampaign: [],
      isShowRecurring: true,
      data: {
        categoryDropdown: null,
        campaignDropdown: null,
        locationDropdown: null,
        userDropdown: null,
        startDate: null,
        recurring: false,
      },
      dataRef: {
        categoryDropdown: "categoryDropdown",
        campaignDropdown: "campaignDropdown",
      },
      dataRef2: {
        locationDropdown: "locationDropdown",
      },
      errors: {
        categoryDropdown: null,
        campaignDropdown: null,
        locationDropdown: null,
        startDate: null,
      },
      categoryOptions: [
        {
          id: 1,
          value: 0,
          label: "Visit"
        },
        {
          id: 2,
          value: 1,
          label: "Maintenance"
        },
      ],
      themeStyles: {
        dayContent: {
          fontSize: '15px',
        },
        headerTitle: {
          fontSize: '17px',
          fontWeight: 'bold'
        },
        weeks: {
          fontWeight: 'bold'
        },
        wrapper: {
          boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.16)',
          backgroundColor: 'white',
          border: 'none',
        },
        header: {
          marginBottom: '6px'
        },
        dayCellNotInMonth: {
          opacity: 0,
        }
      },
    }
  },
  computed: {

  },
  watch: {
    'data.campaignDropdown': function (after, before) {
      if (before != '' && this.data.campaignDropdown != '') {
        let filteredCampaign = this.storedCampaign.filter(opt => opt.id === this.data.campaignDropdown)
        if (filteredCampaign[0]) this.maxDate = new Date(filteredCampaign[0].end)

        this.data.locationDropdown = null
        this.getLocation()
      }
    },
    'data.startDate': function () {
      if (this.data.startDate) {
        this.errors.startDate = null
      }
    }
  },
  beforeCreate() {

  },
  created() {
    this.loadData()
  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    backToAssignment() {
      this.$router.push({name: "taskassignment"})
    },
    async loadData() {
      this.isLoading = true

      // Campaign list
      const campaignResponse = await api.get(apiV2.taskManagerCampaignList, { needToken: true })
      if (campaignResponse.status === 200) {
        const { data } = campaignResponse
        this.storedCampaign = data
        data.map(obj => {
          this.campaignOptions.push({
            id: obj.id,
            label: obj.title,
            value: obj.id
          })
        })
      } else {
        this.$notify({
          group: 'saved',
          title: 'Error',
          text: `Sorry something went wrong! (Error code: ${campaignResponse.status})`,
          type: 'warn'
        })
      }

      // User list
      const opsResponse = await api.get(apiV2.getTeamOps, { needToken: true })
      if (opsResponse.status === 200) {
        const { data } = opsResponse

        data.map(obj => {
          this.userOptions.push({
            id: obj.id,
            label: obj.full_name,
            value: obj.email
          })
        })
      } else {
        this.$notify({
          group: 'saved',
          title: 'Error',
          text: `Sorry something went wrong! (Error code: ${opsResponse.status})`,
          type: 'warn'
        })
      }

      this.isLoading = false
    },
    async getLocation() {
      this.isLocationLoading = true
      this.locationOptions = []

      // Campaign's location list
      const response = await api.get(apiV2.taskManagerCampaignLocationList(this.data.campaignDropdown), { needToken: true })
      if (response.status === 200) {
        const { data } = response
        data.map(obj => {
          this.locationOptions.push({
            id: obj.id,
            label: `${obj.location} - ${obj.placement}`,
            value: obj.id
          })
        })
      } else {
        this.$notify({
          group: 'saved',
          title: 'Error',
          text: `Sorry something went wrong! (Error code: ${response.status})`,
          type: 'warn'
        })
      }

      this.isLocationLoading = false
    },
    async save() {
      let isValid = await triggerValidation(
        this.data,
        this.dataRef,
        this.$refs,
        this.errors
      );

      if (!this.data.locationDropdown) {
        this.errors.locationDropdown = 'This field is required! Please enter Location'
        isValid = false
      } else {
        this.errors.locationDropdown = null
        isValid = true
      }

      if (!this.data.startDate && isValid) {
        this.errors.startDate = 'This field is required! Please enter Start Date'
        isValid = false
      } else if (this.data.startDate){
        this.errors.startDate = null
        isValid = true
      }

      if (isValid) {
        let body = {
          category: this.data.categoryDropdown,
          date: moment(this.data.startDate, 'DD-MM-YYYY').format('YYYY-MM-DD'),
          location: this.data.locationDropdown,
          recurring: this.data.recurring
        }

        if (this.data.userDropdown) body['user'] = this.data.userDropdown
  
        // save task
        const response = await api.post(apiV2.taskManagerCreateTask, body, { needToken: true })
        if (response.status === 201) {
          this.$notify({
            group: 'saved',
            title: 'Success',
            text: `Task successfully created!`,
            type: 'success'
          })
          this.$router.push({name:"taskassignment"})
        } else {
          this.$notify({
            group: 'saved',
            title: 'Error',
            text: `Sorry something went wrong! (Error code: ${response.status})`,
            type: 'warn'
          })
        }
      }

    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>